import React from 'react';
import { Link } from 'react-router-dom';
import { CLINIC_SOCIAL_LINKS } from '../data/socialLinks';
import { useLocale } from '../context/LocaleContext';
import { useBookAppointmentModal } from '../context/BookAppointmentModalContext';
import { paths } from '../routes/paths';
import LibroReclamacionesBadge from './LibroReclamacionesBadge';
import './LowerFooter.css';

const CLINIC_MAPS_URL =
  'https://maps.app.goo.gl/ZcuCg67p7StV3LBU7';

function LowerFooter() {
  const { t } = useLocale();
  const { openBookAppointmentModal } = useBookAppointmentModal();

  return (
    <footer className="site_footer" aria-label="Pie de página">
      <div className="site_footer_inner page-shell">
        <section className="site_footer_actions" aria-label={t('footer.patientTitle')}>
          <Link to={paths.login} className="site_footer_btn site_footer_btn--login">
            <span className="site_footer_login_icon">
              <i className="fa-solid fa-user-check" aria-hidden="true"></i>
            </span>
            <span className="site_footer_login_label">{t('topbar.patientLogin')}</span>
          </Link>
          <button
            type="button"
            className="site_footer_btn site_footer_btn--booking"
            onClick={openBookAppointmentModal}
          >
            <i className="fa-regular fa-calendar-check" aria-hidden="true"></i>
            <span>{t('stickyBook')}</span>
          </button>
        </section>

        <nav className="site_footer_seo_links" aria-label={t('footer.seoLinksAria')}>
          <Link to={paths.emergency}>{t('footer.emergency')}</Link>
        </nav>

        <LibroReclamacionesBadge className="lr_badge--footer" />

        <section className="site_footer_contact">
          <address className="site_footer_address">
            <a
              className="site_footer_address_link"
              href={CLINIC_MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('footer.address')}
            </a>
          </address>
        </section>

        <section
          className="site_footer_social"
          aria-label={t('topbar.socialAria')}
        >
          {CLINIC_SOCIAL_LINKS.map((link) => (
            <a
              key={link.id}
              className="site_footer_social_link"
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t(link.labelKey)}
            >
              <i className={link.iconClass} aria-hidden="true"></i>
            </a>
          ))}
        </section>
      </div>
    </footer>
  );
}

export default LowerFooter;
